class CategoriaTarifa {
  constructor() {
    this.id = null;
    this.idCliente = null;
    this.nome = null;
    this.idCategoriaTarifa = null;
    this.datavigenciaInicial = null;
    this.datavigenciaFinal = null;
  }
}
export default CategoriaTarifa;